import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import { JSX, useContext, useEffect } from "react";
import AdequacyBreakdownExport from "../Exports/AdequacyBreakdownExport";
import CompositeFillableGapsExport from "../Exports/CompositeFillableGapsExport";
import EcdReportPreviewTile from "./EcdReportPreviewTile";
import LineOfBusinessExport from "../Exports/LineOfBusinessExport";
import CountyStatusExport from "../Exports/CountyStatusExport";
import TopCountiesByGapExport from "../Exports/TopCountiesByGapExport";
import TopSpecialtiesByGapExport from "../Exports/TopSpecialtiesByGapExport";
import ExceptionsExport from "../Exports/ExceptionsExport";
import GapOverviewExport from "../Exports/GapOverviewExport";
import GapsByAgeExport from "../Exports/GapsByAgeExport";
import FiltersExport from "../Exports/FiltersExport";
import { EcdReportGenerationStepProps } from "../interfaces";
import PageSection from "@app/shared/PageSection";

const EcdReportGenerationExportPreview = (props: EcdReportGenerationStepProps): JSX.Element => {
  const wizardContext = useContext(EcdGenerateReportContext);
  let currentPageNumber = 1;

  useEffect(() => {
    const anyPage = wizardContext.includeAdequacyBreakdown || wizardContext.includeCompositeFillableGaps || wizardContext.includeCountyStatus ||
      wizardContext.includeExceptions || wizardContext.includeFilterPage || wizardContext.includeGapOverview || wizardContext.includeGapsByAge ||
      wizardContext.includeLineOfBusiness || wizardContext.includeTopCounties || wizardContext.includeTopSpecialties;
    props.pageIsValid(anyPage);
  },
    [
      wizardContext.includeAdequacyBreakdown, wizardContext.includeCompositeFillableGaps, wizardContext.includeCountyStatus,
      wizardContext.includeExceptions, wizardContext.includeFilterPage, wizardContext.includeGapOverview, wizardContext.includeGapsByAge,
      wizardContext.includeLineOfBusiness, wizardContext.includeTopCounties, wizardContext.includeTopSpecialties
    ])

  return (
    <>
    <PageSection>
        <br />
        <hr className="mt-0" />
        <p className="demibold text-gray-dark">The pages will export as shown below:</p>
        <br />
    </PageSection>
      <div className="ecd-export-preview">
        <PageSection>
          <div className="enterprise-compliance-dashboard__content row ecd-export-preview__inner">
            {wizardContext.includeFilterPage && (<EcdReportPreviewTile tileContent={<FiltersExport />} title={"FiltersPage_" + currentPageNumber++} />)}
            {wizardContext.includeAdequacyBreakdown && (<EcdReportPreviewTile tileContent={<AdequacyBreakdownExport />} title={"AdequacyBreakdown_" + currentPageNumber++} />)}
            {wizardContext.includeGapOverview && (<EcdReportPreviewTile tileContent={<GapOverviewExport />} title={"GapOverview_" + currentPageNumber++} />)}
            {wizardContext.includeCompositeFillableGaps && (<EcdReportPreviewTile tileContent={<CompositeFillableGapsExport />} title={"CompositeFillableGaps_" + currentPageNumber++} />)}
            {wizardContext.includeGapsByAge && (<EcdReportPreviewTile tileContent={<GapsByAgeExport />} title={"GapsByAge_" + currentPageNumber++} />)}
            {wizardContext.includeExceptions && (<EcdReportPreviewTile tileContent={<ExceptionsExport />} title={"Exceptions_" + currentPageNumber++} />)}
            {wizardContext.includeTopSpecialties && (<EcdReportPreviewTile tileContent={<TopSpecialtiesByGapExport />} title={"TopSpecialties_" + currentPageNumber++} />)}
            {wizardContext.includeTopCounties && (<EcdReportPreviewTile tileContent={<TopCountiesByGapExport />} title={"TopCounties_" + currentPageNumber++} />)}
            {wizardContext.includeLineOfBusiness && (<EcdReportPreviewTile tileContent={<LineOfBusinessExport />} title={"LineOfBusiness_" + currentPageNumber++} />)}
            {wizardContext.includeCountyStatus && (<EcdReportPreviewTile tileContent={<CountyStatusExport />} title={"CountyStatus_" + currentPageNumber++} />)}
          </div>
        </PageSection>
      </div>
    </>
  );
}

export default EcdReportGenerationExportPreview;